import WelcomeCoachContainer from "../../container/coach/welcomeCoach/welcomeCoachContainer";

const WelcomeCoach = (): React.JSX.Element => <WelcomeCoachContainer />;

export default WelcomeCoach;
